import { render, staticRenderFns } from "./Notenerfassung.vue?vue&type=template&id=1aa2e4c0"
import script from "./Notenerfassung.vue?vue&type=script&lang=js"
export * from "./Notenerfassung.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports